import eightBall from '../assets/images/ball/eight-ball.png';
import nineBall from '../assets/images/ball/nine-ball.png';
import tenBall from '../assets/images/ball/ten-ball.png';

export const getGameType = type => {
	return type.indexOf('EIGHT_BALL') !== -1
		? eightBall
		: type.indexOf('NINE_BALL') !== -1 ? nineBall : type.indexOf('TEN_BALL') !== -1 ? tenBall : null;
};
